import { render } from "./TranslucentOverlay.vue?vue&type=template&id=53532f0d&scoped=true"
import script from "./TranslucentOverlay.vue?vue&type=script&lang=js"
export * from "./TranslucentOverlay.vue?vue&type=script&lang=js"

import "./TranslucentOverlay.vue?vue&type=style&index=0&id=53532f0d&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-53532f0d"

export default script